
export default {
  name: 'schedule-cities',
  props: {
    list: {
      type: Array,
      required: true,
    }
  },
};
